import { createSelector } from 'reselect'

const employeeImageSelector = state => Object.values(state.employeeImages)
const employeeUsernameSelector = state => Object.keys(state.employeeImages)
const employeeImages = state => state.employeeImages

export {
  employeeImageSelector,
  employeeUsernameSelector,
  employeeImages,
}
